/* tslint:disable */

/**
 */
export class ViewFamily {
    LABEL?: string;
    ID_TRANSLATION?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-family.ts